import { Injectable } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { FclLoginService } from './fcllogin.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { User } from '../model/user';

@Injectable({
  providedIn: 'root'
})
export class SpotfireService {

  user: User = new User();
  fedExDomain = '.fedex.com';
  cookiesSet = false;
  logisticsDomain = '.logistics.fedex.com';

  constructor(
    private http: HttpClient,
    private fclLoginService: FclLoginService,
    private oktaAuth: OktaAuthService) {

  }

  public setSportFireUser(spotfireReport: string): Observable<any> {
    const user = this.fclLoginService.getUser();

    if (this.fclLoginService.getUserType() === 'I') {
      const headers = {
        'Content-Type': 'application/json',
        OBLIX_UID: this.getCookie('OBLIX_UID'),
        jwtToken: this.getCookie('jwtToken')
      };
      return this.http.get<any>(spotfireReport, { headers, withCredentials: true });
    } else if (this.fclLoginService.getUserType() === 'E') {
      const headers = {
        'Content-Type': 'application/json',
        OBLIX_UID: this.getCookie('OBLIX_UID'),
        fcl_contactname: this.getCookie('fcl_contactname'),
        fdx_login: this.getCookie('fdx_login'),
        fcl_fname: this.getCookie('fcl_fname'),
        fclUuid: this.getCookie('fcl_uuid')
      };
      return this.http.get<any>(spotfireReport, { headers, withCredentials: true });
    } else {
      return of('ERROR');
    }
  }

  getCookie(cname): string {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let c of ca) {
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }


  async setTokenOrCookie(){
    this.user = this.fclLoginService.getUser();
    if (this.fclLoginService.getUserType() === 'I') {
      /* clear any external user cookies*/
      const accessToken = await this.oktaAuth.getAccessToken();
      document.cookie = `fdx_login=;domain=${this.fedExDomain}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `fcl_uuid=;domain=${this.fedExDomain}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `fdx_login=;domain=${this.logisticsDomain}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `fcl_uuid=;domain=${this.logisticsDomain}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

      /* Add internal user cookies*/
      document.cookie = `OBLIX_UID=${this.user.fedExId};domain=${this.fedExDomain}`;
      // document.cookie = `jwtToken=${accessToken};domain=${this.fedExDomain}`;
      document.cookie = `jwtToken='TestToken';domain=${this.fedExDomain}`;
      document.cookie = `OBLIX_UID=${this.user.fedExId};domain=${this.logisticsDomain}`;
      document.cookie = `jwtToken='TestToken';domain=${this.logisticsDomain}`;

    } else if (this.fclLoginService.getUserType() === 'E') {
      const spotFireUserId = this.user.fclUuid;

      /* clear any internal user  cookies*/
      document.cookie = `jwtToken='TestToken';domain=${this.fedExDomain}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `jwtToken='TestToken';domain=${this.logisticsDomain}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

      /* Add external user cokkies*/
      document.cookie = `OBLIX_UID=${spotFireUserId};domain=${this.fedExDomain}`;
      document.cookie = `fdx_login=${spotFireUserId};domain=${this.fedExDomain}`;
      document.cookie = `fcl_uuid=${spotFireUserId};domain=${this.fedExDomain}`;

      document.cookie = `OBLIX_UID=${spotFireUserId};domain=${this.logisticsDomain}`;
      document.cookie = `fdx_login=${spotFireUserId};domain=${this.logisticsDomain}`;
      document.cookie = `fcl_uuid=${spotFireUserId};domain=${this.logisticsDomain}`;
    }
  }

}
